var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['icon-container', _vm.color],style:({ '--icon-size': (_vm.size + "px") })},[_c('img',{attrs:{"src":("/images/plan-ahead/plan-image/" + _vm.icon + ".png"),"alt":"Plan icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }